import { SaleX } from "./interface";

export namespace NumberUtil {
  interface IUniformDistArg {
    MIN: number;
    MAX: number;
  }

  interface INormalDistArg {
    MEAN: number;
    STD: number;
  }

  export function uniformDist({ MIN, MAX }: IUniformDistArg, fix: number = 0): number {
    return +(MIN + Math.random() * (MAX - MIN)).toFixed(fix);
  }

  export function normalDist({ MEAN, STD }: INormalDistArg, fix: number = 0) {
    let sum = -6;
    for (let i = 0; i < 12; i++) {
      sum += Math.random();
    }
    return +(MEAN + sum * STD).toFixed(fix);
  }

  export enum Range {
    I,
    II,
    III,
    IV,
  }

  export function normalizeUniformDist(n: number, { MIN, MAX }: IUniformDistArg): Range {
    const v = (n - MIN) / (MAX - MIN);
    switch (true) {
      case v <= 0.25:
        return Range.I;
      case v <= 0.5:
        return Range.II;
      case v <= 0.75:
        return Range.III;
      default:
        return Range.IV;
    }
  }

  export function normalizeNormalDist(n: number, { MEAN, STD }: INormalDistArg): Range {
    switch (true) {
      case n <= MEAN - STD:
        return Range.I;
      case n <= MEAN:
        return Range.II;
      case n <= MEAN + STD:
        return Range.III;
      default:
        return Range.IV;
    }
  }

  export function getMin(numbers: number[]): number {
    return numbers.map((n) => n).sort((s1, s2) => s1 - s2)[0];
  }

  export function getMax(numbers: number[]): number {
    return numbers.map((n) => n).sort((s1, s2) => s2 - s1)[0];
  }

  export function geneInsuranceTerms(utility: number) {
    const AccidentList = [
      "意外身亡",
      "人身伤残",
      "爆炸事故",
      "火灾",
      "自然灾害",
      "大病医疗",
      "交通事故",
      "涉及第三者的财产损",
      "医治期间的治疗费用",
      "电信诈骗",
    ];
    const termList = AccidentList.slice(Math.random() * AccidentList.length * 0.5)
        .map((_, i) => ~~((i + Math.random()) * 100) * 100)
        .reverse(),
      QList = termList.map((_, i) => i + 1 + Math.random()),
      E = termList.map((t, i) => t * QList[i]).reduce((m, n) => m + n, 0),
      scale = utility / E;
    return termList.map((price, i) => ({
      accident: AccidentList[i],
      price,
      q: +(QList[i] * scale).toFixed(4),
    }));
  }
}

export function getXPercent(X: SaleX[], buyX: SaleX): number {
  if (!X.length) {
    return 0;
  }
  return +(X.filter((x) => x === buyX).length / X.length).toFixed(2);
}

export async function waitSeconds(n: number) {
  return new Promise<void>((resolve) => setTimeout(() => resolve(), n * 1e3));
}

const CONST = {
  MAX_BUY_P: 1.2,
};

export function calcDepositP(
  saleCost: number,
  deposit: number,
  price: number
): {
  pBuy: number;
  pDeposit: number;
} {
  const MAX_DEPOSIT_RATIO = 0.2;
  const pBuy = -0.5 * (price / saleCost) + CONST.MAX_BUY_P,
    depositRatio = deposit / saleCost,
    pDeposit = ((MAX_DEPOSIT_RATIO - depositRatio) / MAX_DEPOSIT_RATIO + pBuy) / 2;
  return { pBuy, pDeposit };
}

export function calcBuyNowP(
  saleCost: number,
  discountPrice: number,
  price: number
): {
  pBuy: number;
  pBuyNow: number;
} {
  const pBuy = CONST.MAX_BUY_P - 0.5 * (discountPrice / saleCost),
    pBuyNow = CONST.MAX_BUY_P - discountPrice / price;
  return { pBuy, pBuyNow };
}

export function calcScore(worst: number, n: number, best: number, badLimit = worst, goodLimit = best) {
  const baseScore = 50;
  const profitScore = ~~((baseScore + (100 - baseScore) * ((n - worst) / (best - worst))) * 0.15),
    compareScore = ~~((baseScore + (100 - baseScore) * ((n - badLimit) / (goodLimit - badLimit))) * 0.6);
  return ~~((profitScore + compareScore) / 0.75);
}

export function enumVals<E>(e: E): E[keyof E][] {
  return Object.values(e)
    .filter((key) => typeof key !== "number")
    .map((key) => e[key]);
}
